import React from "react";
import { Text, type TextProps } from "@chakra-ui/react";
import { useShadcnInsetChrome } from "@/contexts/ShadcnInsetChromeContext";

/** Large Urbanist page title — hidden when inset breadcrumbs already show the route name. */
export function PageRouteHeadline({
  children,
  ...props
}: TextProps & { children: React.ReactNode }) {
  const shadcnInset = useShadcnInsetChrome();
  if (shadcnInset) return null;

  return (
    <Text
      fontSize={{ base: "2xl", md: "3xl" }}
      color="#38BBD1"
      fontWeight="normal"
      fontFamily="'Urbanist', sans-serif"
      flexShrink={0}
      {...props}
    >
      {children}
    </Text>
  );
}
